"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreCard = StoreCard;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/StoreCard/index.tsx
// ストアの pickup カード。クリック可能 (href リンク または onClick)。
//
// 外殻は internal/Tappable (ButtonBase) で包んだ GlassCard (glassmorphism +
// shadow.cardGlass) で、内側に 2:1 のサムネイル画像とコンテンツを縦積み。
// pickup ラベルは Badge(subtle/primary)、商品数テキストは
// foreground.neutral.secondary、タイトルは 16px / W600 /
// foreground.neutral.primary。
// サムネイルが未設定のときは <img src=""> を描かず、プレースホルダ面だけを出す。
//
// 色・影はすべて theme.palette.v2 (useV2Palette) とトークンから取得。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Badge_1 = require("../Badge");
var GlassCard_1 = require("../GlassCard");
var Tappable_1 = require("../internal/Tappable");
function StoreCard(_a) {
    var imageUrl = _a.imageUrl, title = _a.title, pickupLabel = _a.pickupLabel, itemCountLabel = _a.itemCountLabel, href = _a.href, onClick = _a.onClick;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(Tappable_1.Tappable, { href: href, onClick: onClick, sx: Tappable_1.CARD_TAPPABLE_SX, children: (0, jsx_runtime_1.jsxs)(GlassCard_1.GlassCard, { sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        position: 'relative',
                        width: '100%',
                        paddingTop: '50%', // 2:1 aspect ratio
                        backgroundColor: p.background.neutral.default,
                        overflow: 'hidden',
                        flexShrink: 0,
                    }, children: !!imageUrl && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", src: imageUrl, alt: title, sx: {
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        } })) }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.sm + 2, "px"), sx: { px: "".concat(tokens_1.spacing.md, "px"), py: "".concat(tokens_1.spacing.md - 2, "px") }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: "".concat(tokens_1.spacing.sm, "px"), alignItems: "center", children: [pickupLabel && ((0, jsx_runtime_1.jsx)(Badge_1.Badge, { label: pickupLabel, variant: "subtle", color: "primary" })), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                        fontSize: tokens_1.fontSize.sm,
                                        fontWeight: tokens_1.fontWeight.medium,
                                        lineHeight: "".concat(tokens_1.lineHeight.sm, "px"),
                                        color: p.foreground.neutral.secondary,
                                    }, children: itemCountLabel })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                fontSize: tokens_1.fontSize.base,
                                fontWeight: tokens_1.fontWeight.semiBold,
                                lineHeight: "".concat(tokens_1.lineHeight.base, "px"),
                                color: p.foreground.neutral.primary,
                            }, children: title })] })] }) }));
}
